module.exports = __webpack_public_path__ + "images/eurocross52c60749f1055e61237c77b28a271a7a.png";